import { Module, StatusPanelDef } from '@ag-grid-community/core'
import { EnterpriseCoreModule } from '@ag-grid-enterprise/core'
import { StatusBarModule } from '@ag-grid-enterprise/status-bar'
import { SelectedRowsStatusBarComp } from '@helios/generic-components'
import { WorkbenchMarketValueStatusBarComp } from './workbench-money-status-bar'
import { WorkbenchRangeSumStatusBarComp } from './workbench-range-sum-status-bar'
import { WorkbenchRowsStatusBarComp } from './workbench-rows-status-bar'
import { WorkbenchUnitsStatusBarComp } from './workbench-units-status-bar'

export const workbenchStatusBarModuleName =
  'hsPositionsWorkbenchStatusBarModule'
export const workbenchRowsStatusBar = 'hsPositionsWorkbenchRowsStatusBar'
export const workbenchSelectedRowsStatusBar =
  'hsPositionsWorkbenchSelectedRowsStatusBar'
export const workbenchUnitsStatusBar = 'hsPositionsWorkbenchUnitsStatusBar'
export const workbenchMarketValueStatusBar =
  'hsPositionsWorkbenchMarketValueStatusBar'
export const workbenchRangeSumStatusBar =
  'hsPositionsWorkbenchRangeSumStatusBar'

/**
 * The workbench footer: counts on the left, selection totals on the right. Every summary panel
 * collapses when it has nothing to report, which is how source-specific panels stay out of the way
 * without being reconfigured on a source swap.
 */
export const workbenchStatusBarPanel: { statusPanels: StatusPanelDef[] } = {
  statusPanels: [
    { statusPanel: workbenchRowsStatusBar, align: 'left' },
    { statusPanel: workbenchSelectedRowsStatusBar, align: 'left' },
    { statusPanel: workbenchUnitsStatusBar, align: 'right' },
    { statusPanel: workbenchMarketValueStatusBar, align: 'right' },
    { statusPanel: workbenchRangeSumStatusBar, align: 'right' },
  ],
}

export const WorkbenchStatusBarModule: Module = {
  moduleName: workbenchStatusBarModuleName,
  userComponents: [
    {
      componentName: workbenchRowsStatusBar,
      componentClass: WorkbenchRowsStatusBarComp,
    },
    {
      // Reused verbatim from Positions 1.0 so `Selected: n` is the same component, not a lookalike.
      componentName: workbenchSelectedRowsStatusBar,
      componentClass: SelectedRowsStatusBarComp,
    },
    {
      componentName: workbenchUnitsStatusBar,
      componentClass: WorkbenchUnitsStatusBarComp,
    },
    {
      componentName: workbenchMarketValueStatusBar,
      componentClass: WorkbenchMarketValueStatusBarComp,
    },
    {
      componentName: workbenchRangeSumStatusBar,
      componentClass: WorkbenchRangeSumStatusBarComp,
    },
  ],
  dependantModules: [StatusBarModule, EnterpriseCoreModule],
}
